import styled, {keyframes} from 'styled-components/macro';
import theme from 'styled-theming';
import {colors, dark} from '@styles/vars';
import {useEffect, useRef, useState} from 'react';
import {useLocation} from 'react-router-dom';

const enter = keyframes`
  from {
    width: 0;
    opacity: 1;
  }

  to {
    width: 88%;
    opacity: 1;
  }
`;

const finish = keyframes`
  from {
    width: 88%;
    opacity: 1;
  }

  to {
    width: 100%;
    opacity: 0;
  }
`;

const Track = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background-color: ${theme('theme', {
    light: colors.light_gray,
    dark: dark.highlight
  })};
  z-index: 10000000;
  pointer-events: none;
`;

const Bar = styled.div`
  height: 100%;
  background-color: ${colors.blue};
  animation: ${enter} 360ms ease-out forwards, ${finish} 220ms ease-in 360ms forwards;
`;

const RouteChangeProgress = () => {
  const {pathname} = useLocation();
  const [visible, setVisible] = useState(false);
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    setVisible(true);
    const timer = window.setTimeout(() => {
      setVisible(false);
    }, 620);

    return () => {
      window.clearTimeout(timer);
    };
  }, [pathname]);

  if (!visible) {
    return null;
  }

  return (
    <Track aria-hidden="true">
      <Bar />
    </Track>
  );
};

export default RouteChangeProgress;
